// @flow

import { UPDATE_SORT } from '../constants';
import type { SortDirection, SortType } from '../../../helpers/compare/compare';

export type UpdateSort = {|
  type: typeof UPDATE_SORT,
  payload: {
    property: string,
    direction: SortDirection,
    type: SortType,
  },
|};

export const updateSort = (
  property: string,
  direction: SortDirection,
  type: SortType,
): UpdateSort => ({
  type: UPDATE_SORT,
  payload: {
    direction,
    property,
    type,
  },
});

export default null;
